import React from 'react';
import { replace, push } from 'react-router-redux';
import { updateURLQuery } from 'oo-routes';

const isBrowser = typeof window === 'object';

class Page extends React.Component {
  static frozen = isBrowser && window.__SP_PAGE_INIT_STATE__;
  static initialState = isBrowser && window.__SP_PAGE_INIT_STATE__;
  static listeners = [];

  static freeze() {
    Page.frozen = true;
  }

  static defrost() {
    Page.frozen = false;
  }

  static subscribe(listener) {
    Page.listeners.push(listener);
    let listenerIndex = Page.listeners.length - 1;
    return Page.unsubsribe.bind(Page.unsubsribe, listenerIndex);
  }

  static unsubsribe(index) {
    Page.listeners.splice(index, 1);
  }

  static broadcast(newState) {
    for (let listener of Page.listeners) {
      listener(newState);
    }
  }

  constructor(props) {
    super(props);
    if (Page.initialState) {
      this.state = Page.initialState;
      Page.initialState = null;
    }
    Page.broadcast(this.state);
  }

  componentWillUpdate(nextProps) {
    // Reset scroll when route and/or params chagned when both routes use the same component
    if (this.props.location.pathname !== nextProps.location.pathname) {
      if (isBrowser) {
        window.scrollTo(0, 0);
      }
    }
  }

  // Reset scroll when route change when routes use different component
  componentWillUnmount() {
    if (isBrowser) {
      window.scrollTo(0, 0);
    }
  }

  setState(newState, cb) {
    if (!Page.frozen) {
      super.setState(newState, () => {
        if (isBrowser) {
          Page.broadcast(this.state);
        }
        if (cb) {
          cb();
        }
      });
    }
  }

  updateURLQuery(update, options) {
    if (options && options.nav === 'push') {
      this.props.dispatch(
        push(
          updateURLQuery(
            this.props.location.pathname,
            this.props.location.query,
            update)));
    }

    this.props.dispatch(
      replace(
        updateURLQuery(
          this.props.location.pathname,
          this.props.location.query,
          update)));
  }
}

export default Page;

if (isBrowser) {
  window.__SP_PAGE__ = Page;
  // Put it in the window object so that developer can freeze or defrost in the console
}



// WEBPACK FOOTER //
// ./~/sp-components/components/Page/index.jsx